import appConfig from 'app.config'
import { useTranslation } from 'react-i18next'
import { ICustomer } from 'selfServicePortal/interfaces/i-api-customer'

export const CustomerInformationForm = (data: ICustomer) => {
	const { t } = useTranslation()
	return {
		fieldSetName: t('ContactInformationHeader'),
		formName: 'CustomerInformation',
		description: '',
		collapsable: false,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'customer.name',
				type: 'text',
				label: t('Name'),
				value: `${data.firstName} ${data.lastName}`,
				visible: true,
				fullSize: true,
				col: 12,
				disabled: true,
			},
			{
				required: true,
				controlName: 'customer.street',
				type: 'text',
				label: t('Street'),
				value: data.street,
				visible: true,
				maxLength: 50,
				col: 9,
				readonly: true,
				validations: [
					{
						code: 'Invalid',
						message: t('ValidationMsgStreet'),
					},
				],
			},
			{
				required: false,
				controlName: 'customer.houseNumber',
				type: 'text',
				label: t('Nr'),
				value: data.houseNumber,
				visible: true,
				readonly: true,
				col: 3,
				maxLength: 5,
			},
			{
				required: true,
				controlName: 'customer.postalCode',
				type: 'number',
				label: t('Zip'),
				value: data.postalCode,
				visible: true,
				readonly: true,
				col: 4,
				maxLength: 5,
				validations: [
					{
						code: 'MustMatchPattern',
						value:
							appConfig.country === 'de'
								? '\\b\\d{5}\\b'
								: '\\b\\d{4}\\b',
						message: t('ValidationMsgZip'),
					},
				],
			},
			{
				required: true,
				controlName: 'customer.city',
				type: 'text',
				label: t('City'),
				value: data.city,
				visible: true,
				readonly: true,
				col: 8,
				maxLength: 40,
			},
			{
				required: true,
				controlName: 'customer.mobilePhoneNumber',
				type: 'tel', //change back to phoneNumber when formbuilder is updated
				label: t('PhoneNumber'),
				value: data.mobilePhoneNumber,
				visible: true,
				fullSize: true,
				col: 12,
				maxLength: 15,
				options: [
					{
						value: appConfig.country.toUpperCase(),
						label: appConfig.country.toUpperCase(),
					},
				],
				validations: [
					{
						code: 'Invalid',
						message: t('InvalidPhone'),
					},
				],
				countryCode: 'NO',
				wrapperClass: 'tel-container-wrapper ' + appConfig.country, //Add this class for now when using type "tel"
			},
			{
				required: true,
				controlName: 'customer.email',
				type: 'email',
				label: t('Email'),
				value: data.email,
				visible: true,
				fullSize: true,
				col: 12,
				maxLength: 40,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '\\S+@\\S+\\.\\S+',
						message: t('ValidationMsgEmail'),
					},
				],
			},
		],
	}
}
